const UKIndexs = ['.hsi', 'hscei', 'hscci', 'dia', 'ndaq', 'spy', 'qqq']

export const getIsIndexStock = function (symbol, market) {
  if (!symbol || !market) return false
  if (market.toLocaleUpperCase() === 'HKIDX') return true
  if (UKIndexs.includes(symbol.toLowerCase())) return true
  if (market !== 'sz' && market !== 'sh') return false
  const symbolS3 = symbol.slice(0, 3)
  if (market === 'sz') return symbolS3 === '399'
  if (market === 'sh') return symbolS3 === '000'
  return false
}